import { GENERIC_REFERRAL_DOMAIN } from "./incomingTrafficConsts";

export const compareGenericReferralLast = (a: { Domain?: string }, b: { Domain?: string }): number =>
    Number(a.Domain === GENERIC_REFERRAL_DOMAIN) - Number(b.Domain === GENERIC_REFERRAL_DOMAIN);
